/** Decorative star glyph — parent control owns `aria-pressed` / `aria-label` (C3 ★ filter). */
export function FavoriteStarIcon({
  filled,
  className = 'h-5 w-5',
}: {
  readonly filled: boolean;
  readonly className?: string;
}): JSX.Element {
  if (filled) {
    return (
      <svg
        className={className}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M12 2.5l2.9 6.1 6.7.8-4.9 4.5 1.3 6.6L12 17.8 5.9 20.5l1.3-6.6L2.4 9.4l6.7-.8L12 2.5z"
        />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
        d="M12 3.2l2.6 5.5 6 .7-4.4 4.1 1.2 5.9L12 16.5 6.6 19.4l1.2-5.9L3.4 9.4l6-.7L12 3.2z"
      />
    </svg>
  );
}
